import { OnChangeCallbackData } from '#coreComponents/Select';
import {
  QUERY_SELECT_ONE_CHANGE,
  QUERY_SELECT_TWO_CHANGE,
  QUERY_SELECT_THREE_CHANGE,
  YEAR_CHANGE,
} from './constants';

export const onYearChange = (payload: number[]) => ({
  type: YEAR_CHANGE,
  payload,
});

export const onQuerySelectOneChange = (payload: OnChangeCallbackData[]) => ({
  type: QUERY_SELECT_ONE_CHANGE,
  payload,
});

export const onQuerySelectTwoChange = (payload: OnChangeCallbackData[]) => ({
  type: QUERY_SELECT_TWO_CHANGE,
  payload,
});

export const onQuerySelectThreeChange = (payload: OnChangeCallbackData[]) => ({
  type: QUERY_SELECT_THREE_CHANGE,
  payload,
});
